module.exports = __webpack_public_path__ + "static/redmine-5eb629734328c21ac27f13c6af176011.png";